import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '728ba945-1f2c-45df-ac60-50f49fe35583',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '132818d3-530d-44d1-83b9-a96a964888cc',
      type: 'Graphics',
      name: 'gfx',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '728ba945-1f2c-45df-ac60-50f49fe35583',
      bake: false,
      commands: [
        {
          id: 'b38f9537-692f-4e63-b22a-d396b8700b07',
          type: 'beginFill',
          color: 0,
          alpha: 0.8
        },
        {
          id: '1ad72d61-3ed5-40e8-a948-552a1c112f0a',
          type: 'drawRect',
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        }
      ]
    },
    {
      id: 'e8d2a93e-7353-43d9-8e33-447aaaf2af6e',
      type: 'Graphics',
      name: 'spinner',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '728ba945-1f2c-45df-ac60-50f49fe35583',
      bake: false,
      commands: [
        {
          id: 'bde6d615-b8bd-4847-8435-a4514775f333',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'dceb1f6d-4da1-4ad4-a217-c422dd30b0df',
          type: 'drawCircle',
          x: 0,
          y: -20,
          radius: 6
        },
        {
          id: '01ac4022-78f3-4438-b452-2cecbc5e099a',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.8
        },
        {
          id: 'ad633157-ce2e-4f7f-98ab-a7e839a2e5d1',
          type: 'drawCircle',
          x: 14,
          y: -14,
          radius: 6
        },
        {
          id: 'cfb197d5-8c47-4699-99d5-ae99d9afe883',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.6
        },
        {
          id: 'f44a9867-8d5d-400a-8b04-91ab95e23281',
          type: 'drawCircle',
          x: 20,
          y: 0,
          radius: 6
        },
        {
          id: '6d97913f-8906-4ee0-8f46-0f96c6762340',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.4
        },
        {
          id: '08140574-bca9-4e53-9abb-ea1339ad3f7f',
          type: 'drawCircle',
          x: 14,
          y: 14,
          radius: 6
        },
        {
          id: 'a76722ac-5922-4333-86e8-d90d989b8b72',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.2
        },
        {
          id: '497bf03e-1f75-4126-a497-19be6ab6b7b5',
          type: 'drawCircle',
          x: 0,
          y: 20,
          radius: 6
        },
        {
          id: '92f6266d-c5ff-48a7-8949-c2a0b0ca5078',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.1
        },
        {
          id: '3480440a-890a-446c-a2b9-91adc56db2e2',
          type: 'drawCircle',
          x: -14,
          y: 14,
          radius: 6
        },
        {
          id: '9fd5cee6-157a-4391-b369-e813d40fac97',
          type: 'beginFill',
          color: 16777215,
          alpha: 0.05
        },
        {
          id: 'a58af2e5-2874-4d23-9824-dabf78ed2130',
          type: 'drawCircle',
          x: -20,
          y: 0,
          radius: 6
        }
      ]
    }
  ],
  x: 50,
  y: 50,
  width: 640,
  height: 960,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  gfx: boolean;
  spinner: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly gfx: PIXI.Graphics;
  public readonly spinner: PIXI.Graphics;


  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
